export const common = {
  welcome: 'ようこそ',
  home: 'ホーム',
  about: '会社概要',
  services: 'サービス',
  contact: 'お問い合わせ',
  learnMore: '詳しく見る',
  getStarted: '始める',
  submit: '送信',
  cancel: 'キャンセル',
  close: '閉じる',
  save: '保存',
  edit: '編集',
  delete: '削除',
  search: '検索',
  loading: '読み込み中...',
  error: 'エラーが発生しました',
  success: '成功しました',
  reserveNow: 'ご予約はこちらから',
};